import React from 'react';
import exact from 'prop-types-exact';
import PageLayout from '../../layouts/PageLayout/index';
import CollectionStatusTable from './components/CollectionStatusTable';
import { routerProps } from '../../propTypes';

const propTypes = exact({
  ...routerProps,
});


const TimesheetCollectionStatusPage = (props) => {
  return (
    <div>
      <PageLayout
        title="Timesheet Collection Status"
        render={() => { return <CollectionStatusTable />; }}
      />
    </div>
  );
};


TimesheetCollectionStatusPage.propTypes = propTypes;


export default TimesheetCollectionStatusPage;
